import { Button } from "@/components/ui/button"
import { ToastProvider, useToast } from "@/components/ui/toast"

export function ToastPreviewRoute(): JSX.Element {
  return (
    <ToastProvider>
      <ToastPreviewInner />
    </ToastProvider>
  )
}

function ToastPreviewInner(): JSX.Element {
  const { toast } = useToast()

  return (
    <div className="mx-auto max-w-4xl px-8.5 py-11">
      <header className="mb-8">
        <div className="font-id text-eyebrow uppercase tracking-[0.16em] text-text-3">
          Primitive
        </div>
        <h1 className="mt-1 text-display text-text">Toast</h1>
      </header>

      <Section title="Tones">
        <Button
          onClick={() =>
            toast({
              tone: "neutral",
              title: "Neutral toast",
              body: "A plain notification with no severity.",
            })
          }
        >
          Fire neutral
        </Button>
        <Button
          variant="primary"
          onClick={() =>
            toast({
              tone: "success",
              title: "Report sent",
              body: "The client will see it shortly.",
            })
          }
        >
          Fire success
        </Button>
        <Button
          variant="destructive"
          onClick={() =>
            toast({
              tone: "error",
              title: "Something failed",
              body: "This toast will not auto-dismiss.",
            })
          }
        >
          Fire error
        </Button>
      </Section>

      <Section title="With undo action">
        <Button
          onClick={() =>
            toast({
              title: "Finding 12 dismissed",
              body: "It will not appear on the client's report.",
              action: { label: "Undo", onAction: () => undefined },
            })
          }
        >
          Fire with undo
        </Button>
      </Section>
    </div>
  )
}

function Section({ title, children }: { title: string; children: React.ReactNode }): JSX.Element {
  return (
    <section className="mb-8">
      <h2 className="mb-3.5 font-id text-caption uppercase tracking-[0.16em] text-text-3">
        {title}
      </h2>
      <div className="flex flex-wrap items-center gap-3.5">{children}</div>
    </section>
  )
}
